import React from "react";
import { Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faArrowLeft, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import "./ErrorLoadDoc.css"

interface ErrorLoadDocProps {
  onRetry?: () => void;
  onGoBack?: () => void;
}

const ErrorLoadDoc: React.FC<ErrorLoadDocProps> = ({ onRetry, onGoBack }) => {
  return (
    <div className="er_si_wrapper d-flex align-items-center justify-content-center">
      <Card className="er_si_card text-center">
        <div className="er_si_icon_wrapper">
          <FontAwesomeIcon icon={faExclamationCircle} className="er_si_icon" />
        </div>

        <h4 className="er_si_title">Failed to Load Document</h4>

        <p className="er_si_description">
          We couldn't load this document. This might be due to a network issue,
          the file being corrupted, or insufficient permissions.
        </p>

        <div className="er_si_actions">
          <Button
            className="er_si_retry_btn"
            onClick={onRetry}
          >
            <FontAwesomeIcon icon={faRotateRight} className="me-2" />
            Try Again
          </Button>

          <Button
            variant="outline-secondary"
            className="er_si_back_btn"
            onClick={onGoBack}
          >
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
            Go Back
          </Button>
        </div>

        <div className="er_si_common_issues">
          <p className="er_si_common_title">Common issues:</p>
          <ul>
            <li>Check your internet connection</li>
            <li>Verify you have permission to view this file</li>
            <li>The file may be corrupted or deleted</li>
            <li>Try refreshing the page</li>
          </ul>
        </div>
      </Card>
    </div>
  );
};

export default ErrorLoadDoc;
